import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { Observable } from 'rxjs';

@Injectable()
export class KeepAliveService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    keepAlive(): Observable<any> {
        return this.http.get<any>(`${this.environment.api}me/keep_alive`);
    }
}
